import { LoginSetupInterface } from '../../../interfaces/response/login-setup/login-setup-interface';

export class LoginSetupModel implements LoginSetupInterface {
  canSubscribeToAgentArea: boolean = false;
  registerType: string = '';
  isDiscontinued: boolean = false;
  ssoEntities: string[] = new Array<string>();
  isAgentCodeAutogenerated: boolean = false;

  constructor(init?: Partial<LoginSetupModel>) {
    Object.assign(this, init);
  }
}
